import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import SEO from "@/components/SEO";

export default function PaymentCancel() {
  return (
    <div className="py-20 lg:py-28" data-testid="payment-cancel-page">
      <SEO title="Payment Cancelled" />
      <div className="max-w-xl mx-auto px-4 text-center">
        <XCircle className="w-12 h-12 text-slate-300 mx-auto" />
        <h1 className="mt-5 font-heading text-3xl font-extrabold text-slate-900">Payment cancelled</h1>
        <p className="mt-3 text-slate-500">No amount was charged. Your holiday plans are still waiting — book whenever you're ready, or request a custom quote instead.</p>
        <div className="mt-7 flex items-center justify-center gap-3">
          <Link to="/packages" data-testid="payment-cancel-packages"
                className="rounded-full bg-navy px-7 py-3.5 font-heading font-bold text-white hover:bg-royal transition-colors">
            Browse Holidays
          </Link>
          <Link to="/" className="rounded-full border border-navy px-7 py-3.5 font-heading font-bold text-navy hover:bg-navy hover:text-white transition-colors">
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
